/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://qi7rjtdpkrhg7avhmpqd2ux3sm.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "us-east-1:ed3e2e8a-c672-4db5-a3e5-54b6a954a8ab",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_NaOjSE0x0",
    "aws_user_pools_web_client_id": "qfojvjulrd328md5l844apa7s",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "Auth": {
        "Cognito": {
            "userPoolId": "us-east-1_NaOjSE0x0",
            "userPoolClientId": "qfojvjulrd328md5l844apa7s"
        }
    }
};


export default awsmobile;
